import { StepComponentName } from '../ActivationFlow/constants/componentNames';
// Pre-account step components
import MeetAccountableBanking from '../Onboarding/steps/MeetAccountableBanking.component';
import PeppolBanking from '../Onboarding/steps/PeppolBankingStep';
import AutomaticallyReserveTaxes from '../Onboarding/steps/AutomaticallyReserveTaxes.component';
import FullTransparency from '../Onboarding/steps/FullTransparency.component';
// fixed by adding lazy import in useWalletOnboardingModal file
// ESLint can't detect lazy imports in static analysis
import OnboardingForm from '../Onboarding/steps/OnboardingForm.component';
import PersonalInfoStep from '../Onboarding/steps/PersonalInfoStep';
import BusinessAddressStep from '../Onboarding/steps/BusinessAddressStep';
import BusinessActivityStep from '../Onboarding/steps/BusinessActivityStep';
import FinanzamtDocUploader from '../Onboarding/steps/FinanzamtDocUploader.component';
import BornDetailsStep from '../Onboarding/steps/BornDetailsStep';
import ResidencyDetailsStep from '../Onboarding/steps/ResidencyDetailsStep';
import ConfirmIdentity from '../Onboarding/steps/ConfirmIdentity.component';

// Post-account step components
import SummaryStep from '../components/SummaryStep';
import HowIsIntegratedStep from '../ActivationFlow/steps/HowIsIntegratedStep';
import TaxesDescriptionStep from '../ActivationFlow/steps/TaxesDescriptionStep';
import AccIbanOnInvoicesStep from '../ActivationFlow/steps/AccIbanOnInvoicesStep';
import IssueCardStep from '../ActivationFlow/steps/IssueCardStep';
import CardDesignStep from '../ActivationFlow/steps/IssueCardStep/CardDesignStep';
import YourCardReadyStep from '../ActivationFlow/steps/YourCardReadyStep';
import CardToWalletStep from '../ActivationFlow/steps/CardToWalletStep';
import TopUpStep from '../ActivationFlow/steps/TopUpStep';
import ReadyToGoStep from '../ActivationFlow/steps/ReadyToGoStep';

/**
 * Component registry - centralizes all step component imports
 * Separated from stepDefinitions.ts to break circular dependencies
 */
export const STEP_COMPONENTS: Record<
  StepComponentName,
  React.ComponentType<any>
> = {
  // General
  [StepComponentName.SummaryStep]: SummaryStep,

  // Pre-account (sign up) steps
  [StepComponentName.MeetAccountableBanking]: MeetAccountableBanking,
  [StepComponentName.PeppolBanking]: PeppolBanking,
  [StepComponentName.ExpensesDescription]: IssueCardStep,
  [StepComponentName.AccIbanOnInvoicesOnboardingStep]: AccIbanOnInvoicesStep,
  [StepComponentName.TaxesDescription]: TaxesDescriptionStep,
  [StepComponentName.FullTransparency]: FullTransparency,
  [StepComponentName.OnboardingForm]: OnboardingForm,
  [StepComponentName.PersonalInfoStep]: PersonalInfoStep,
  [StepComponentName.BusinessAddressStep]: BusinessAddressStep,
  [StepComponentName.BusinessActivityStep]: BusinessActivityStep,
  [StepComponentName.FinanzamtDocUploader]: FinanzamtDocUploader,
  [StepComponentName.BornDetailsStep]: BornDetailsStep,
  [StepComponentName.ResidencyDetailsStep]: ResidencyDetailsStep,
  [StepComponentName.ConfirmIdentity]: ConfirmIdentity,

  // Post-account (activation) steps
  [StepComponentName.HowIsIntegratedStep]: HowIsIntegratedStep,
  [StepComponentName.TaxesDescriptionStep]: TaxesDescriptionStep,
  [StepComponentName.AccIbanOnInvoicesActivationStep]: AccIbanOnInvoicesStep,
  [StepComponentName.IssueCardStep]: IssueCardStep,
  [StepComponentName.CardDesignStep]: CardDesignStep,
  [StepComponentName.YourCardReadyStep]: YourCardReadyStep,
  [StepComponentName.CardToWalletStep]: CardToWalletStep,
  [StepComponentName.TopUpStep]: TopUpStep,
  [StepComponentName.ReadyToGoStep]: ReadyToGoStep,
};
